/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{flex:1;display:flex}[_nghost-%COMP%]   form[_ngcontent-%COMP%]{flex:1;display:flex;justify-content:space-around;align-items:center}[_nghost-%COMP%]   form[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:0;max-width:36px;min-width:36px;max-height:36px;min-height:36px}"];
export { styles as styles };
